import React, { Component } from 'react';
import Box from './Box';

class CheckCall extends Component {
    myCall = (params) => {
        alert(params)
    }
    componentWillMount(){
        const script = document.createElement('script');
        script.src = "https://checkout.razorpay.com/v1/checkout.js"
        document.body.appendChild(script);
    }
    onPayment = () => {
        // const { duration } = this.state;
        // const tmonths = duration == 1 ? 1 : 12;
        const amount = 100;
        // Generate Options
        const options = {
            key: 'rzp_test_6jYJLtlkbso9dU',
            amount, // 2000 paise = INR 20
            name: 'ilrnu',
            description: 'Plan Upgrade',
            currency: localStorage.getItem("currency") || 'INR',
            // image: 'https://www.ivneu.com/static/media/logo.a87fb833.png',
            image: 'https://www.ilrnu.com/static/media/Header_logo.e04394ae.svg',
            handler(response) {
                console.log(response);
                // alert(response.razorpay_payment_id);
                /* const data = {
                    plan: 1,
                    duration: tmonths,
                    payment_id: response.razorpay_payment_id,
                    currency: 'USD'
                };
                dispatch(modalAction({ loadModel: true, msg: success.updatePlan }));
                dispatch(razorPay(data, history)); */
            },
            // prefill: {
            //     name: '',
            //     email: ''
            // },
            theme: {
                color: '#649EDF'
            }
        };
        // const rzp = new Razorpay(options);
        const rzp1 = new window.Razorpay(options)
        rzp1.open();
    }
    render() {
        return (
            <>
                <div className="">
                    <Box boxCall={this.myCall} />

                </div>
                <button className="btn btn-lg btn-primary" onClick={()=>this.onPayment()}>Pay Now</button>
            </>
        )
    }
}

export default CheckCall;
